export function RoleUtils<R extends readonly [string, ...string[]]>(roles: R) {
  type Role = R[number];
  const rank = Object.fromEntries(roles.map((r, i) => [r, i])) as Record<Role, number>;
  const compare = (a: Role, b: Role) => rank[b] - rank[a];
  const isAtLeast = (actual: Role, required: Role) => rank[actual] <= rank[required];
  const validate = (role: string): role is Role => roles.includes(role as Role);

  return { roles, rank, compare, isAtLeast, validate } as const;
}
